import axiosInstance from '../utils/axiosInstance';
import { BaseListView } from '../utils/Interface';

export const GetChurchListApi = async () =>
  await axiosInstance
    .get('/api/church/')
    .then((res) => res.data as BaseListView<Church>)
    .catch((err) => null);
